// extracted by mini-css-extract-plugin
module.exports = {"chart":"ForceGraph_chart__v87vX","links":"ForceGraph_links__Kwjsu","nodes":"ForceGraph_nodes__tuZJS","node":"ForceGraph_node__1OAYv"};